import React, { PureComponent } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import {
  TITLE,
  INSTRUCTION_STRINGS,
  DESCRIPTION,
  HINT,
  SAMPLE_TABLE_DATA,
  LIMIT_UPLOAD_NUMBER,
  STEP_STRINGS,
} from './const';
import { BulkAARUpload } from './bulk-aar-upload';
import { getBulkAarHeaderStyle } from '../style/bulk-aar-header-style';

export class RecommendationBulkAAR extends PureComponent {
  static propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    newI18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
  };

  renderColumn(string, newI18n) {
    return (
      <li>
        {newI18n.getString(string, { number: LIMIT_UPLOAD_NUMBER })}
      </li>
    );
  }

  renderSampleTableData(column) {
    return (
      <tr>
        <td>{column.accountId}</td>
        <td>{column.recommendationType}</td>
        <td>{column.optIn}</td>
      </tr>
    );
  }

  render() {
    const {
      i18n, newI18n, classes,
    } = this.props;

    const instructionStrings = _.map(INSTRUCTION_STRINGS, string => this.renderColumn(string, newI18n));
    const stepStrings = _.map(STEP_STRINGS, string => this.renderColumn(string, newI18n));
    const sampleTableData = _.map(SAMPLE_TABLE_DATA, data => this.renderSampleTableData(data));
    const sampleTable = (
      <table>
        <thead>
          <tr>
            <td>Account ID</td>
            <td>Recommendation Type</td>
            <td>Opt-in</td>
          </tr>
        </thead>
        <tbody>
          {sampleTableData}
        </tbody>
      </table>
    );

    return (
      <div className="recommendation-bulk-aar" >
        <h4 className={classes.title}>
          {newI18n.getString(TITLE)}
        </h4>
        <p className={classes.bulkAarDescription}>
          {newI18n.getString(DESCRIPTION)}
        </p>
        <BulkAARUpload
          {...this.props}
          i18n={i18n}
          newI18n={newI18n}
        />
        <div className={classes.bulkAarInstruction}>
          <div className={classes.bulkAarInstructionStep}>
            <strong>{newI18n.getString(_TL_('Instructions:'))}</strong>
            <ol>
              {instructionStrings}
            </ol>
          </div>
          <div className={classes.sampleTable}>
            <p>
              {newI18n.getString(HINT)}
            </p>
            {sampleTable}
          </div>
        </div>
        <div className={classes.bulkAarStep}>
          <strong>{newI18n.getString(_TL_('The bulk update tool follow the steps below to update AAR status:'))}</strong>
          <ol>
            {stepStrings}
          </ol>
        </div>
      </div>
    );
  }
}

export const StyledRecommendationBulkAAR =
  withDefaultStyles(RecommendationBulkAAR, getBulkAarHeaderStyle);
